import React from 'react';

import ActionButton from '../../../components/ActionButton/ActionButton';
import { ModalContentWrapper, SuccessMessageDescriptionText } from './styles';
import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';

type FeedbackSuccessMessageProps = {
  handleReset: () => void;
};

const FeedbackSuccessMessage: React.FC<FeedbackSuccessMessageProps> = ({
  handleReset,
}) => {
  const { t } = useI18n();

  return (
    <ModalContentWrapper>
      <SuccessMessageDescriptionText>
        {t(TranslationKeys.feedbackSuccessMessage_description)}
      </SuccessMessageDescriptionText>
      <ActionButton
        onClickAction={handleReset}
        buttonText={t(TranslationKeys.common_closeButton)}
        variant="accept-blue"
      />
    </ModalContentWrapper>
  );
};

export default FeedbackSuccessMessage;
